if (!customElements.get('custom-select')) {
  customElements.define(
    'custom-select',
    class customSelect extends HTMLElement {
      constructor() {
        super();

        this.select = this.querySelector('select');
        this.selectedText = this.querySelector('.select-selected');
        this.selectItems = this.querySelector('.select-items');

        this.options = this.selectItems.querySelectorAll('.select-item');
        this.options.forEach((option) => {
          option.addEventListener('click', () => {
            this.setValue(option.dataset.value);

            this.selectItems.classList.add('select-hide');
            this.selectedText.classList.remove('select-arrow-active');

            this.triggerEvent();
          });
        });

        this.selectedText.addEventListener('click', (e) => {
          e.stopPropagation();

          this.selectItems.classList.toggle('select-hide');
          this.selectedText.classList.toggle('select-arrow-active');
        });
      }

      setValue(value) {
        const selectedOption = Array.from(this.options).find((o) => o.dataset.value === value);

        this.dataset.value = value;
        this.dataset.href = selectedOption.dataset.href;

        this.select.value = value;
        this.selectedText.innerHTML = selectedOption.innerHTML;

        this.options.forEach((item) => {
          item.classList.remove('same-as-selected');
        });
        selectedOption.classList.add('same-as-selected');
      }

      triggerEvent(event = 'change') {
        this.dispatchEvent(new Event(event));
      }
    },
  );
}

if (!customElements.get('collections-panel')) {
  customElements.define(
    'collections-panel',
    class CollectionsPanel extends HTMLElement {
      constructor() {
        super();

        this.hero = document.querySelector('.all-products-top');
        this.herodescription = this.hero.querySelector('.c-container > p');
        this.desktopHeroTitle = this.hero.querySelector('.title-desktop');
        this.mobileHeroTitle = this.hero.querySelector('.title-mobile');
        this.filterPanel = this.querySelector('.filter-panel');
        this.filterMobile = this.querySelector('custom-select');

        if (this.filterPanel) {
          this.searchInput = this.filterPanel.querySelectorAll('input[type="search"]');
          this.tabsBtns = this.filterPanel.querySelectorAll('.slider .button');
        }

        this.tabs = this.querySelectorAll('.products-panel-component');
        this.empty = this.querySelector('.empty-category-container');
        this._href = window.location.href;

        this.tabsBtns.forEach((btn) => {
          btn.addEventListener('click', (element) => {
            element.preventDefault();
            this.updateURL(element.target.dataset.href);
            this.activeTab = element.target.dataset.target;
            if(this.filterMobile){
              this.filterMobile.setValue(element.target.dataset.target);
            }
            this.updateHero(element.target.dataset.target);
            this.hideElementsFromBranded(element.target.dataset.target);
            this.hideReadmoreSection(element.target.dataset.target);
          });

          if (btn.dataset.href === window.location.pathname) {
            btn.click();
          }
        });

        if (this.searchInput.length > 0) {
          this.searchInput.forEach((element) => {
            element.addEventListener('input', (e) => {
              const target = 'all';

              this.updateURL(`/collections/${target}?q=${element.value}`);

              this.activeTab = target;
              if(this.filterMobile){
                this.filterMobile.setValue(target);
              }
              this.filterList(e.target.value);
              this.updateHero(target);
              this.hideElementsFromBranded(target);
              this.hideReadmoreSection(target);
            });
          });
        }

        this.filterMobile.addEventListener('change', () => {
          this.updateURL(this.filterMobile.dataset.href);
          this.activeTab = this.filterMobile.dataset.value;
          this.updateHero(this.filterMobile.dataset.value);
          this.hideElementsFromBranded(this.filterMobile.dataset.value);
          this.hideReadmoreSection(this.filterMobile.dataset.value);
        });

        window.addEventListener('scroll', () => {
          const offset = this.hero.clientHeight;

          if (window.pageYOffset <= offset || document.documentElement.scrollTop <= offset)
            if (this.filterPanel) {
              this.filterPanel.classList.remove('filter-fixed');
            } else {
              if (this.filterPanel) {
                this.filterPanel.classList.add('filter-fixed');
                this.filterPanel.style.top = `${this.fixedTopDistance}px`;
              }
            }
        });
      }

      get fixedTopDistance() {
        return document.querySelector('.app-banner') ? 130 : 130;
      }

      set activeTab(target) {
        this.tabs.forEach((tab) => {
          if (tab.classList.contains(target)) {
            this._activeTab = tab;
            this.classList.add(target);
            this._activeTab = tab;
            tab.classList.remove('hide');
          } else {
            this.classList.remove(target);
            tab.classList.add('hide');
          }
        });

        this.tabsBtns.forEach((btn) => {
          if (btn.dataset.target == target) {
            this.classList.add(btn.dataset.target);
            btn.classList.remove('button-transparent');
          } else {
            this.classList.remove(btn.dataset.target);
            btn.classList.add('button-transparent');
          }
        });
      }

      get activeTab() {
        return this._activeTab;
      }

      get list() {
        return this.querySelectorAll('.product-preview-container');
      }

      get hiddenItems() {
        return this.querySelectorAll('.product-preview-container.hide');
      }

      updateURL(url) {
        history.pushState({}, '', url);
      }

      filterList(queryString) {
        this.empty.classList.add('hide');
        this.activeTab.classList.add('hide');
        const query = queryString.toLowerCase().trim();

        if (query !== '') {
          this.tabs.forEach((tab) => {
            const items = tab.querySelectorAll('.product-card-container');

            items.forEach((item) => {
              const titleElement = item.querySelector('.title');
              const descriptionElement = item.querySelector('.description');

              let title = '';
              if (titleElement) {
                title = titleElement.textContent.toLowerCase();
              }

              let description = '';
              if (descriptionElement) {
                description = descriptionElement.textContent.toLowerCase();
              }

              if (title.includes(query) || description.includes(query)) {
                item.classList.remove('hide');
              } else {
                item.classList.add('hide');
              }
            });

            const hiddenItems = tab.querySelectorAll('.product-card-container.hide');
            if (hiddenItems.length == items.length) {
              tab.classList.add('hide');
            } else {
              tab.classList.remove('hide');
            }
          });

          const hiddenTabs = this.querySelectorAll('.products-panel-component.hide');
          if (hiddenTabs.length == this.tabs.length) this.empty.classList.remove('hide');
          else this.empty.classList.add('hide');
        } else {
          this.updateURL('/collections/all');
          this.activeTab = 'all';
          this.list.forEach((item) => {
            const items = item.querySelectorAll('.product-card-container');

            items.forEach((item) => {
              item.classList.remove('hide');
            });

            item.classList.remove('hide');
          });
        }
      }

      /**
       * Updates the hero section with the provided target handle.
       * @param {string} options.targetHandle - The handle of the target element.
       */
      updateHero(targetHandle) {
        const target = this.querySelector(`.products-panel-component.${targetHandle}`);

        let newTitle = null;
        let newDescription = null;
        let allProductsTitle = null;
        let allProductsDescription = null;
        let innerTitle = null;
        let innerDescription = null;

        if (target) {
          const titleElement = target.querySelector('.title-wrapper');
          if (titleElement && titleElement.dataset.heroTitle) {
            newTitle = titleElement.dataset.heroTitle;
          }

          if (titleElement && titleElement.dataset.heroDescription) {
            newDescription = titleElement.dataset.heroDescription;
          }

          allProductsTitle = target.querySelector('.title-wrapper .title.all-products-title');
          allProductsDescription = target.querySelector('.title-wrapper .all-products-description');
          innerTitle = target.querySelector('.title-wrapper .title.inner-title');
          innerDescription = target.querySelector('.title-wrapper .inner-description');
        }

        if (Array.from(this.tabs).every((tab) => !tab.classList.contains('hide'))) {
          const defaultTitle = this.tabs[0].dataset.defaultHeroTitle;
          const defaultDescription = this.tabs[0].dataset.defaultHeroDescription;

          allProductsTitle.style.display = 'block';
          allProductsDescription.style.display = 'block';
          innerTitle.style.display = 'none';
          innerDescription.style.display = 'none';

          this.desktopHeroTitle.innerHTML = defaultTitle;
          this.mobileHeroTitle.innerHTML = defaultTitle;
          this.herodescription.innerHTML = defaultDescription;
        } else {
          allProductsTitle.style.display = 'none';
          allProductsDescription.style.display = 'none';
          innerTitle.style.display = 'block';
          
          if (innerDescription) {
            innerDescription.style.display = 'block';
          }

          if (newTitle) {
            this.desktopHeroTitle.innerHTML = newTitle;
            this.mobileHeroTitle.innerHTML = newTitle;
          }
          if (newDescription) {
            this.herodescription.innerHTML = newDescription;
          }
        }
      }

      hideElementsFromBranded(target) {
        Array.from(this.tabs).forEach((tab) => {
          const productCard = tab.querySelectorAll('.product-list-component .product-card-container');

          productCard.forEach((card) => {
            if (card.dataset.hasOwnProperty('excludeFromList')) {
              if (target === 'custom-boxes') {
                card.classList.add('hide');
              } else {
                card.classList.remove('hide');
              }
            }
          });
        });
      }

        /**
       * Hides the read more section based on the target sections to keep.
       * @param {string} target - Current collection section.
       * @param {string[]} sectionsToKeep - The sections to keep visible when hiding the read more section.
       */
      hideReadmoreSection(target, sectionsToKeep = ['custom-boxes', 'custom-cosmetic-packaging']) {
        const readMoreSection = document.querySelector('.shopify-section.read-more');

        if (readMoreSection) {
          if (!sectionsToKeep.includes(target)) {
            readMoreSection.classList.add('hide');
          } else {
            readMoreSection.classList.remove('hide');
          }
        }
      }
    },
  );
}
